import {
  Checkbox,
  Stack,
  Menu,
  MenuButton,
  MenuList,
  Flex,
  Box,
} from '@tonic-one/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrgStore } from '@Models/useOrgModel';
import RenderLabel from '@Components/OgranizationCheckbox/RenderLabel';
import { InlineError } from '@Components/Common/FormikComponent';
import { useRoleDefinitionStore } from '@Models/rbac/useRoleDefinition';
export const OrganizationCheckbox = () => {
  const { t } = useTranslation();
  const orgModel = useOrgStore();
  const orgs = orgModel.orgs?.filter((x) => x.key !== 'all');
  const { orgManagementIds, setOrgManagementIds, errorMsg, setErrorMsg } =
    useRoleDefinitionStore();
  const [checkedItems, setCheckedItems] = useState(
    orgs ? orgs.map(() => false) : []
  );
  const [allChecked, setAllChecked] = useState(false);
  const [isIndeterminate, setIsIndeterminate] = useState(false);
  const width = 328;
  const maxWidth =
    typeof width === 'number'
      ? `calc(${width}px - 48px)`
      : `calc(${width} - 48px)`;
  function toggleValue(index: number, value: boolean) {
    const array = [...checkedItems];
    setErrorMsg(undefined);
    if (index >= 0 && index < array.length) {
      array[index] = value;
    }
    if (value === false) {
      setAllChecked(false);
    }
    setCheckedItems(array);
    console.log('array', array);
    setOrgManagementIds(
      orgs ? orgs.filter((_, index) => array[index]).map((org) => org.key) : []
    );
    return array;
  }

  useEffect(() => {
    if (orgManagementIds === 'all') {
      setCheckedItems(orgs ? orgs.map(() => true) : []);
      setAllChecked(true);
    } else {
      setAllChecked(false);
      setCheckedItems(
        orgs ? orgs.map((org) => orgManagementIds.includes(org.key)) : []
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgManagementIds]);

  useEffect(() => {
    setIsIndeterminate(checkedItems.some(Boolean) && !allChecked);
  }, [checkedItems, allChecked]);

  return (
    <>
      <Menu>
        <MenuButton
          variant="secondary"
          width={328}
          {...(errorMsg !== undefined && { borderColor: '#f24c4f' })}
        >
          <Flex maxWidth={maxWidth}>
            {RenderLabel(allChecked, checkedItems)}
          </Flex>
        </MenuButton>
        <MenuList
          p="8px 8px"
          maxHeight="280px"
          overflowY="scroll"
          maxWidth={328}
        >
          <Checkbox
            checked={allChecked}
            indeterminate={isIndeterminate}
            onChange={(e) => {
              setCheckedItems(checkedItems.map(() => e.target.checked));
              setOrgManagementIds(e.target.checked ? 'all' : []);
              setAllChecked(e.target.checked);
            }}
          >
            {t('common.label.allOrganizations')}
          </Checkbox>
          <Stack
            direction="column"
            pl="6x"
            mt="1x"
            spacing="1x"
            shouldWrapChildren
          >
            {orgs &&
              checkedItems.map((item, index) => (
                <Checkbox
                  key={index}
                  checked={item}
                  onChange={(e) => {
                    console.log('e.target.checked', e.target.checked);
                    toggleValue(index, e.target.checked);
                  }}
                >
                  {orgs[index].value}
                </Checkbox>
              ))}
          </Stack>
        </MenuList>
      </Menu>
      <Box>
        {errorMsg !== undefined && <InlineError>{errorMsg}</InlineError>}
      </Box>
    </>
  );
};
